import { render, staticRenderFns } from "./extend-booking-modal.vue?vue&type=template&id=33cfd1cf&"
import script from "./extend-booking-modal.vue?vue&type=script&lang=js&"
export * from "./extend-booking-modal.vue?vue&type=script&lang=js&"
import style0 from "./extend-booking-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
